<template>
  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-dark-success elevation-4" id="aside">

    <!-- Brand Logo -->
    <div class="contenedor_logo">
      <img  src="../img/logo2.png" class="menu_img">
      <span class="texto_logo">Horizon</span>
    </div>

    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar Menu -->
      <nav class="menu_nav">
        <ul class="lista_menu" data-widget="treeview" role="menu" data-accordion="false">

          <li class="lista_item">
            <router-link id="menu_inicio" class="item_menu" :to="{name:'inicioV'}">
              <i class="fas fa-home icono_menu"></i>
              <p class="item_texto">Inicio</p>
            </router-link>
          </li>

          <li class="lista_item">
            <router-link id="menu_acumulaciones" class="item_menu"  :to="{name: 'acumulacionesV'}">
              <i class="nav-icon fa-solid fa-circle-dollar-to-slot icono_menu"></i>
              <p class="item_texto">Acumulaciones</p>
            </router-link>  
          </li>
            
          <li class="lista_item">
            <router-link id="menu_canjes" class="item_menu" :to="{name: 'canjesV'}">
              <i class="nav-icon fa-solid fa-gift icono_menu"></i>
              <p class="item_texto">Canjes</p>
            </router-link>   
          </li>

          <li class="lista_item">
            <router-link id="menu_facturas"  class="item_menu" :to="{name: 'facturasV'}">
              <i class="nav-icon fa-solid fa-receipt icono_menu"></i>
              <p class="item_texto">Facturas</p>
            </router-link> 
          </li>

          <li class="lista_item">
            <router-link id="menu_compartir" class="item_menu" :to="{name: 'canjearPuntosV'}">
              <i class="nav-icon fa-solid fa-cart-shopping icono_menu"></i>
              <p class="item_texto">Canjear Puntos</p>
            </router-link> 
          </li>
        
          <li class="lista_item">
            <router-link id="menu_facturas"  class="item_menu" :to="{name: 'canjesGasolinaV'}">
              <i class="nav-icon fa-solid fa-barcode icono_menu"></i>
              <p class="item_texto">QR's Gasolina</p>
            </router-link>
          </li>

          <li class="lista_item">
            <router-link id="menu_compartir" class="item_menu" :to="{name: 'compartirQRV'}">
              <i class="nav-icon fa-solid fa-share-nodes icono_menu"></i>
              <p class="item_texto">Compartir QR</p>
            </router-link>   
          </li>
          <!--<li class="nav-item">
            <a id="menu_saldo" href="inicio" class="nav-link">
            <i class="nav-icon fa-solid fa-hand-holding-dollar"></i>
              <p>Consultar Saldo</p>
            </a>
          </li> -->
          <li class="lista_item">
            <router-link id="menu_notificaciones" class="item_menu" :to="{name: 'notificacionesV'}">
              <i class="fa-solid fa-comment icono_menu"></i>
              <p class="item_texto">Mensajes</p>
            </router-link>
          </li>

          <li class="lista_item movil_cerrar">
            <router-link id="cerrar_sesion" class="item_menu item_salir" :to="{name: 'loginV'}">
              <i class="nav-icon fas fa-sign-out-alt icono_menu"></i>
              <p class="item_texto" @click="sbLimpiar">Salir</p>
            </router-link>
          </li>
        </ul>
        <!-- <li class="lista_item desktop_cerrar">
            <router-link id="cerrar_sesion" class="item_menu item_salir" :to="{name: 'loginV'}">
              <i class="nav-icon fas fa-sign-out-alt icono_menuenu"></i>
              <p class="item_texto" @click="sbLimpiar">Salir</p>
            </router-link>
        </li> -->
      </nav><!-- /.sidebar-menu -->
    </div><!-- /.sidebar -->
  </aside>
</template>

<script>
export default {
  data() { 
    return {

    }
  },
  methods:{
    sbLimpiar() {
      localStorage.idCliente = 0;
      localStorage.usuario = ""
      localStorage.numeroCliente = ""
      localStorage.pass = ""
      localStorage.nombres = ""
    }
  }
}
</script>

<style>
/* menu fijo */
.main-sidebar{
  position: fixed !important;
  top: 0;
  bottom: 0;
  height: 100vh;

  background: linear-gradient(
    180deg,
    #0d1931 0%,
    #0a2f5f 90%,
    #084185 100%
  );
  border-bottom-right-radius: 20px;
  border-right: 1px solid rgba(255,255,255,.08);
  box-shadow: 4px 0 15px rgba(0, 0, 0, 0.18) !important;
  transition: .3s ease;
}

/* sidebar */
.sidebar{
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  padding: 5px 5px 0 5px;
  height: calc(100vh - 75px);
}

/* logo */
.contenedor_logo{
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding: 8px 10px;
  border-bottom: 2px solid #0a2f5f;
  transition: .3s ease;
  justify-content: flex-start;
  width: 250px;
  height: 50px;
  overflow: hidden;
}

.menu_img{
  height: 40px;
  width: 40px;
  border-radius: 12px;
  padding: 0px;
  background: rgba(255,255,255,.06);
  box-shadow: 1px 2px 10px rgba(65, 98, 168, 0.15);
}

.texto_logo{
  font-size: 22px;
  color: #fff;
  font-weight: 700;
  transition: .2s ease;
}

/* nav */
.menu_nav{
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* menu */
.lista_menu{
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  padding-left: 0;
  margin-bottom: 0;
  margin-top: 5px;
  list-style: none;
}

.lista_item{
  color: #fff;
}

/* linea lateral */
.item_menu::before{
  content: "";
  position: absolute;
  left: 0;
  top: 6px;
  width: 4px;
  height: 0;
  border-radius: 14px;
  background-color: #fff;
  transition: .25s ease;
}

.item_menu:hover::before{
  height: 65%;
}

/* iconos */
.icono_menu{
  min-width: 22px;
  text-align: center;
  font-size: 18px;
  color: #cbd5e1;
  transition: .25s ease;
  margin: 0;
}

.item_menu:hover .icono_menu{
  color: #fff;
}

/* texto */
.item_texto{
  margin: 0;
  white-space: nowrap;
  font-size: 15px;
  font-weight: 500;
  color: #e5e7eb;
  letter-spacing: .3px;
  transition: .2s ease;
}

.item_menu:hover .item_texto{
  color: #fff;
}

/* salir */
.item_salir{
  margin-top: auto;
}

#cerrar_sesion{
  border-top: 1px solid #084185;
  padding-top: 14px;
}

#cerrar_sesion:hover{
  background-color: rgba(255,255,255,.06);
}

/* colapsado */
.sidebar-mini.sidebar-collapse .main-sidebar{
  width: 3.6rem !important;
  overflow: hidden;
  transition: width .3s ease;
}

/* Expandir al pasar cursor */
.sidebar-mini.sidebar-collapse .main-sidebar:hover{
  width: 250px !important;
}

/* Ocultar texto colapsado */
.sidebar-mini.sidebar-collapse .item_texto{
  opacity: 0;
  visibility: hidden;
}

.sidebar-mini.sidebar-collapse .texto_logo{
  opacity: 0;
  visibility: hidden;
  width: 0;
  overflow: hidden;
  /* transition: .2s ease; */
  white-space: nowrap;
  transition: opacity .18s ease;
}

/* Mostrar texto al abrir */
.sidebar-mini.sidebar-collapse .main-sidebar:hover .item_texto{
  opacity: 1;
  visibility: visible;
}

.sidebar-mini.sidebar-collapse .main-sidebar:hover .texto_logo{
  opacity: 1;
  visibility: visible;
  width: auto;
}

.sidebar-mini.sidebar-collapse .main-sidebar:hover .texto_logo{
  opacity: 1;
  visibility: visible;
}

/* .movil_cerrar{
  display: none;
}
@media (max-width: 800px){
  .desktop_cerrar{
    display: none;
  }

  .movil_cerrar{
    display: block;
  }
} */
</style>